import { Component, OnInit, SimpleChanges, ChangeDetectorRef, HostListener, Injector, NgZone } from '@angular/core';
import { Router, RoutesRecognized, NavigationEnd, ActivatedRoute, RouterEvent, NavigationStart, NavigationCancel, NavigationError, Event } from '@angular/router';
//import { User } from 'src/modules/kx-shared/models/user';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { MessagingService } from 'src/modules/base/shared/services/messaging.service';
import { Subscription } from 'rxjs';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TelemedicineModalComponent } from 'src/modules/telemedicine/components/telemedicine-modal/telemedicine-modal.component';
import { TelemedicineService } from 'src/modules/telemedicine/services/telemedicine.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { AmbulanceDocumentComponent } from 'src/modules/kx-shared/components/ambulance-document/ambulance-document.component';
import { LazyService } from './lazy.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { HotkeysService } from 'src/modules/base/services/hotkeys.service';
import { screenShortcut } from 'src/modules/base/components/screen-shortcuts/shortcut.json';
import { SpeedService } from 'src/modules/base/services/speed.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { filter } from 'rxjs/operators';
import { ADService } from './ad.service';
import { AIService } from 'src/modules/base/components/aiml/services/ai.service';
import { AccessibilityService } from 'src/modules/base/services/accessibility.service';
declare var NProgress: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  message;
  hasSubscription = new Subscription();
  openVideocall: boolean = false;
  jsonLoaded: boolean = false;
  // Gates the app-shell-level AI chat embed so it isn't mounted on the login screen. Only
  // flips on login/logout — never on navigation — so the widget still persists across all
  // in-session route changes instead of being torn down and recreated per screen.
  isLoggedIn: boolean = false;
  headerJson: any = {};
  //currentUser: User;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private baseService: BaseService,
    private appService: AppService,
    private route: ActivatedRoute,
    private messagingService: MessagingService,
    private smartModalService: BsModalService,
    private cdr: ChangeDetectorRef,
    public teleService: TelemedicineService,
    public alert: AlertsService,
    public injector: Injector,
    private utilitiesService: UtilitiesService,
    private lazyService: LazyService,
    private hotKeysService: HotkeysService,
    private utilService: UtilService,
    private speedService: SpeedService,
    public preferenceService: PreferenceService,
    private ngZone: NgZone,
    public adService: ADService,
    public aiService: AIService,
    public storageservice?: StorageService,
    public accessibilityService?: AccessibilityService,
  ) {

    if (this.utilService.isTalbet()) {
      if (this.utilService.getWidth() > this.utilService.getHeight()) {
        document.body.classList.add("_tablet", "_landscape")
      }
      else {
        document.body.classList.add("_tablet", "_portrait")
      }
    } else if (this.utilService.isOnlyMobile()) {
      document.body.classList.add("_mobile")
    }

    if (appService.getSessionId()) {
      this.headerJson = this.appService.getAppHeader();
      var promises = [];
      //promises.push(this.lazyService.loadJosnModule(injector,()=>{}));
      promises.push(this.lazyService.loadLanguageFile(injector, () => { }));
      if (this.appService.isFacilityAware()) {
        promises.push(this.lazyService.getFacilityListPromise());
      } else if (this.authenticationService.getUserType() != "patient") {
        promises.push(this.lazyService.getFacilityListPromise());
      }
      promises.push(this.lazyService.loadAccountOnlyConfig());
      promises.push(this.lazyService.loadAccountConfig());
      this.preferenceService.getHeaderPreferences(() => { })
      this.preferenceService.getCommonConfig(() => { });

      Promise.all(promises).then(res => {
        if (utilService.isNotSupported()) {
          this.alert.error("Current browser not supported, Please use chrome for better experience.");
        }
        this.appService.parseAsyncConfig(() => {
          //no need to notify native app if patient
          if (this.authenticationService.getUserType() != "patient") {
            if (this.appService._currentSessionData.qrLoginPassed != undefined && this.appService._currentSessionData.qrLoginPassed != "" && this.appService._currentSessionData.qrLoginPassed != "true") {
              this.baseService.nativeDataHandling("config", JSON.parse(JSON.stringify(this.appService.getAccountConfigValueList())))
            }
          }else{
            this.appService.setAccountWebsiteVisibilityPatient()
          }
        })
        this.jsonLoaded = true;
      });

      this.lazyService.loadAllLazyModules(injector, () => { });
      this.aiService.loadAgents();
      this.baseService.getMobileMenu();
      this.lazyService.loadAccountValues();

    } else {
      this.jsonLoaded = true;
    }

    this.ngZone.runOutsideAngular(() => {
      document.addEventListener(
        'click',
        this.documentClick.bind(this)
      );

      document.addEventListener(
        'mousemove',
        this.documentMouseMove.bind(this)
      );
      document.addEventListener(
        'touchmove',
        this.documentTouchMove.bind(this)
      );
      document.addEventListener(
        'touchstart',
        this.documentTouchStart.bind(this)
      );
      document.addEventListener(
        'touchcancel',
        this.documentTouchCancel.bind(this)
      );
      document.addEventListener(
        'mouseup',
        this.documentMouseup.bind(this)
      );
      document.addEventListener(
        'touchend',
        this.documentTouchEnd.bind(this)
      );
      document.addEventListener(
        'mousedown',
        this.documentMouseDown.bind(this)
      );
      document.addEventListener(
        'mouseleave',
        this.documentMouseLeave.bind(this)
      );
      document.addEventListener(
        'mouseover',
        this.documentMouseOver.bind(this)
      );
      document.addEventListener(
        'window:keyup.ArrowLeft',
        this.documentArrowLeft.bind(this)
      );
      document.addEventListener(
        'window:keyup.ArrowRight',
        this.documentArrowRight.bind(this)
      );
      document.addEventListener(
        'window:keyup.ArrowUp',
        this.documentArrowUp.bind(this)
      );
      document.addEventListener(
        'window:keyup.ArrowDown',
        this.documentArrowDown.bind(this)
      );
      document.addEventListener(
        'window:resize',
        this.documentResize.bind(this)
      );
      document.addEventListener(
        'scroll',
        this.documentScroll.bind(this)
      );
      // document.addEventListener(
      //   'dblclick',
      //   this.documentDblclick.bind(this)
      // );
    })

    if (!this.appService._initialRouteConfig) {
      this.appService._initialRouteConfig = this.router.config;

    }

    this.router.events.pipe(
      filter((e: Event | RouterEvent): e is RouterEvent => e instanceof RouterEvent)
    ).subscribe((e) => {
      this.ngZone.runOutsideAngular(() => {
        this.navigationInterceptor(e);
      });

      if (e instanceof NavigationEnd) {
        appService.setActiveParentMenuId(router);
        setTimeout(() => {
          var classElement = document.getElementsByClassName('nav-item nav-dropdown open');
          if (classElement != undefined && classElement.length > 0) {
            classElement[0].scrollIntoView();
          }
          var sidebarEle = document.querySelector('app-sidebar-nav');
          if (sidebarEle) {
            sidebarEle.scrollTo(0, sidebarEle.scrollTop - 45);
          }
        });
        // appService.routeChanged(router)
      }
    })


    this.baseService.changeDashboardUrl();
    this.baseService.setFavIcon();
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      NProgress.inc();
      NProgress.inc(0.4)
      var currentUser = this.authenticationService.getCurrentUser();
      if (currentUser != null && currentUser != undefined && currentUser.user_type && currentUser.user_type == 'patient') {
        this.validateURL(event); //commented the code because payment gateway
      }
    }
    if (event instanceof NavigationEnd) {
      NProgress.done();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      NProgress.done();
    }
    if (event instanceof NavigationError) {
      NProgress.done();;
    }
  }



  ngOnInit() {
    // CRM redirect temp code we will remove after ninedot implementing
    console.log("hostname --> ", window.location.hostname);
    var currentUser = this.authenticationService.currentUserValue;
    var super_app_url = currentUser?.super_app_url;
    window.addEventListener('flutterNotification', (event: any) => {
      console.log('Notification event from Flutter:', event.detail);
      this.messagingService.setNotificationPayload({notification: event.detail.data});
      this.messagingService.setcolorData(true);
      this.alert.info(event.detail.data.body);
    });
    // var hostname = window.location.hostname;
    // var hosthref = window.location.href;
    if (super_app_url != undefined && super_app_url != "/") {
      // window.location.href= window.location.origin + super_app_url;
    }
    // if(hostname.includes("enterprise")){
    //   if(!hosthref.includes("/crm/")){
    //     window.location.href= window.location.origin + "/crm/";
    //   }
    // }
    // CRM redirect temp code
    if (this.appService.isRTLLayout()) {
      this.lazyService.loadDynamicStyle("/assets/scss/_rtl-layout.css");
    }




    window.addEventListener('storage', this.messageListener.bind(this));

    this.authenticationService.currentUser.subscribe(user => {
      this.isLoggedIn = !!user;
      if (user) {
        navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(async (swr) => {
          try {
            const supported = await this.messagingService.isSupported();
            if (swr && supported) {
              await this.messagingService.initializeMessaging(swr);
              // this.messagingService.angularFireMessaging.useServiceWorker(swr);
              if (this.appService._currentSessionData.configLoaded != undefined) {
                this.messagingService.requestPermission(user['user_id']);
              }
            }
          } catch (e) {
            console.warn("Firebase not supported", e)
          }
        });

        this.messagingService.getPayload().subscribe(result => {
          console.log("message is :: 1", result);
          this.messagingService.setNotificationPayload(result);
          this.messagingService.setcolorData(true);
          if (result) {
            var action = result.notification.title;
            if (action && action.toLowerCase() == 'startvideocall') {
              const config: ModalOptions = {
                backdrop: 'static',
                keyboard: false,
                animated: true,
                ignoreBackdropClick: true,
                initialState: {
                  data: result
                }
              };
              this.smartModalService.show(TelemedicineModalComponent, config);
            } else if (action && action.toLowerCase() == 'videocallend') {
              this.smartModalService.hide(1);
            } else if (action && action.toLowerCase() == 'documentupload') {
              const config: ModalOptions = {
                backdrop: 'static',
                keyboard: false,
                animated: true,
                ignoreBackdropClick: true,
                initialState: {
                  data: result
                }
              };
              this.smartModalService.show(AmbulanceDocumentComponent, config);
            } 
            this.alert.info(result.notification.body);
          }
        });
        //Screen Shortcuts
        if (user['user_type'] == 'patient') { } else if (user.role_type && user.role_type == 'Practitioner') { } else {
          for (var i = 0; i < screenShortcut.length; i++) {
            this.hotKeysService.addShortcut({ keys: screenShortcut[i].key_name, url: screenShortcut[i].url }).subscribe((event: any) => {
              console.log("event is ", event);
              if (event && event.merged && event.merged.url) {
                // this.router.navigate([event.merged.url]);
                this.router.navigate(["/search"]).then(() => {
                  this.router.navigateByUrl(event.merged.url);
                });
              }
            });
          }
        }
        this.adService.initloginWithAD((resp) => { });
      }
    });
    this.teleService.message.subscribe(
      (message) => {
        console.log("inside changes")
        this.openVideocall = message;
        this.cdr.detectChanges();
      }
    );

    this.speedService.startTest();
    this.baseService.generateDeviceID();
  }


  messageListener(obj: any) {
    if (obj.key != undefined) {
      //we could implement more events across tab here
      console.log("Inside messagelistner", obj.key);
      console.log("Inside messagelistner hidden", document.hidden);
      console.log("Inside messagelistner focus", document.hasFocus());
      switch (obj.key) {

        case "reload":
          var super_app_url = this.authenticationService.getCurrentUser().super_app_url;
          console.log("super_app_url -->", super_app_url);
          if (super_app_url == undefined) {
            super_app_url = "/";
          }
          window.location.href = window.location.origin + super_app_url;
          break;
        // case "restReload":
        //   console.log("Inside messagelistner Inside");
        //   if (!document.hasFocus()) {
        //     this.redirectTabs();
        //   }
        //   break;
        default:
          break;
      }
    }
  }

  redirectTabs() {
    try {
      if (sessionStorage.getItem('tabId') != undefined && localStorage.getItem('tabId') != undefined) {
        let arr = [];
        arr = JSON.parse(localStorage.getItem('tabId'));
        let val_ = sessionStorage.getItem('tabId');
        let field = this.checkItems();
        if (field) {
          console.log("Inside messagelistner Inside");
          this.router.navigateByUrl('/');
        }
      }
    } catch (error) {

    }

  }

  checkItems() {
    try {
      if (sessionStorage.getItem('tabId') != undefined && sessionStorage.getItem('tabId')) {
        let sessionObj = JSON.parse(sessionStorage.getItem('tabId'));
        let localObj = JSON.parse(localStorage.getItem('tabId'));
        for (let key in sessionObj) {
          if (sessionObj[key] != localObj[key]) {
            return true;
          }

        }
      }


    } catch (error) { }
  }

  ngOnDestroy() {
    window.removeEventListener("storage", this.messageListener.bind(this));
    // var hit = 0
    // console.log("hit destroy", hit++)
  }
  // @HostListener('document:click', ['$event'])

  documentClick(event: any): void {
    this.utilitiesService.documentClickedTarget.next(event);
  }
  documentMouseup(event: MouseEvent): void {
    this.utilitiesService.documentMouseUpTarget.next(event);
  }
  documentTouchEnd(event: TouchEvent): void {
    this.utilitiesService.documentTouchEndTarget.next(event);
  }
  documentMouseDown(event: MouseEvent): void {
    this.utilitiesService.documentMouseDownTarget.next(event);
  }
  documentMouseMove(event: MouseEvent): void {
    this.utilitiesService.documentMouseMoveTarget.next(event);
  }
  documentTouchMove(event: TouchEvent): void {
    this.utilitiesService.documentTouchMoveTarget.next(event);
  }
  documentMouseLeave(event: MouseEvent): void {
    this.utilitiesService.documentMouseLeaveTarget.next(event);
  }
  documentMouseOver(event: MouseEvent): void {
    this.utilitiesService.documentMouseOverTarget.next(event);
  }
  documentArrowLeft(event: any): void {
    this.utilitiesService.documentArrowLeftTarget.next(event);
  }
  documentArrowRight(event: any): void {
    this.utilitiesService.documentArrowRightTarget.next(event);
  }
  documentArrowUp(event: any): void {
    this.utilitiesService.documentArrowUpTarget.next(event);
  }
  documentArrowDown(event: any): void {
    this.utilitiesService.documentArrowDownTarget.next(event);
  }
  documentResize(event: any): void {
    this.utilitiesService.documentWindowResizeTarget.next(event);
  }
  documentTouchStart(event: TouchEvent): void {
    this.utilitiesService.documentTouchStartTarget.next(event);
  }
  documentTouchCancel(event: TouchEvent): void {
    this.utilitiesService.documentTouchCancelTarget.next(event);
  }
  documentScroll(event: TouchEvent): void {
    this.utilitiesService.documentScrollTarget.next(event);
  }
  // @HostListener('window:beforeunload', ['$event'])
  // onTabRefresh(event: BeforeUnloadEvent) {
  //   debugger;
  //  this.storageservice.removeUrlHistory(window.location.href);
  //  this.storageservice.removeDublicacyInfo();

  // }

  // @HostListener('window:beforeunload', ['$event'])
  // onTabClose(event: BeforeUnloadEvent) {
  //   debugger;
  //   this.storageservice.removeDublicacyInfo();
  //   this.storageservice.removeUrlHistory(window.location.href);
  // }

  validateURL(val) {
    let whiteListedUrls = this.appService.getWhitelisteUrls();
    if (whiteListedUrls != undefined && whiteListedUrls.urls != undefined && whiteListedUrls.urls.length != undefined && whiteListedUrls.urls.length > 0) {
      var allowedUrlsBYDefault = ["/", "/login", "/azure-auth", "/sso-redirect", "/forgotpass", "/account-management/forgotpass", "/account-management/dashboard", "/payment/redirect", "/change_loginId", "/account-management/change_loginId", '/manage_user_pin', "/account-management/manage_user_pin", "/account-management/login", "/account-management/loginwithotp", "/account-management/termsandcondition", "loginwithotpkiosk" ,"/account-management/loginwithotpkiosk","/loginwithkiosk", '/account-management/loginwithkiosk', "/changepass", "/device_auth", "/authenticate_pin", "/404", "/500", "/offline", "/logout"]
      let navUrl = val.url;
      let navPath = navUrl.split('?')[0];
      let feedbackURL = "/patientFeedback/feedBack";
      if (allowedUrlsBYDefault.indexOf(navUrl) > -1 || allowedUrlsBYDefault.indexOf(navPath) > -1) {
        return;
      }
      else if (navUrl.includes(feedbackURL)) {
        return;
      }

      //specific use case for dynamic dashboard
      if (navUrl.startsWith != undefined && navUrl.startsWith("/account-management/dynamic_dashboard/")) {
        return;
      }

      var urlObj: any = this.baseService.getParameters(navUrl, {});

      var index = whiteListedUrls.urls.indexOf(urlObj.url);
      if (index > -1) {
        var allowed = true;
        var params = whiteListedUrls.params[index];
        if (params) {
          for (let par in params) {
            if (urlObj['params'][par] != undefined) {
              if (params[par] != urlObj['params'][par]) {
                allowed = false;
                break;
              }
            }
          }
        }
        if (!allowed) {
          this.router.navigateByUrl("404", { replaceUrl: true });
          return;
        }
      } else {
        var list = urlObj.url.split("/");
        if (list.length == 5 && ["view", "modify"].indexOf(list[4]) > -1) {
          var commonUrl = list.slice(0, -2).join("/");
          var index = whiteListedUrls.urls.indexOf(commonUrl);
          if (index > -1) {
            //allowed
          } else {
            this.router.navigateByUrl("404", { replaceUrl: true });
            return;
          }
        } else {
          if (list.length > 1) {
            var commonUrl = list.slice(0, 2).join("/");
            var index = whiteListedUrls.urls.indexOf(commonUrl);
            if (index > -1) {
              //allowed
              return;
            }
          }
          this.router.navigateByUrl("404", { replaceUrl: true });
          return;
        }
      }
    } else {
      // should work as it is, becasue this case is of no master data found
    }
  }

}
